export interface ILLMOptions {
  model: string;
  temperature: number;
  top_p: number;
  max_tokens: number;
  max_completion_tokens?: number;
  response_format?: {
    type: "json_object";
  };
}

export interface LLMResponse<T> {
  data: T | null;
  cost: number; // cost in dollars
  thresholdExceeded: boolean;
}

export class LLMThresholdExceeded extends Error {
  constructor(taskId: string, message: string = "") {
    super(`taskId: ${taskId}, Message: ${message}`);
    this.name = "LLMThresholdExceeded";
  }
}

export interface ILLMDOMIgnore {
  cssSelectorsToIgnore: string[];
  headerNavigationRoot: string[];
  footerNavigationRoot: string[];
  popupsRoot: string[];
  cookieBannersRoot: string[];
  newsletterPopupsRoot: string[];
  regionalPopupsRoot: string[];
}
